import { Box, Button, Typography } from "@mui/material";
import moment, { Moment } from "moment";
import { useStyles } from "./style";
import { useMemo } from "react";
import empty_schedule from "assets/images/schedule.png";

interface IProps {
  setActiveTab: (agr: number) => void;
  selectedDateTime: { date?: Moment; time: string };
  setSelectedDateTime: (agr: { date?: Moment; time: string }) => void;
  isLoading: boolean;
  availableTime: {
    [key: string]: Array<string>;
  };
}

const TimeSection = ({
  selectedDateTime,
  setSelectedDateTime,
  setActiveTab,
  availableTime,
  isLoading,
}: IProps) => {
  const classes = useStyles();

  const handlePickTime = (time: string) => () => {
    setSelectedDateTime({ ...selectedDateTime, time });
    setActiveTab(2);
  };

  const isExistsMorningTimes =
    selectedDateTime.date &&
    !isNaN(moment(selectedDateTime.date).date()) &&
    availableTime[moment(selectedDateTime.date).format("YYYY-MM-DD")]?.filter(
      (time) => time.split(" ")[1] === "AM"
    )?.length > 0;

  const isExistsAfternoonTimes =
    selectedDateTime.date &&
    !isNaN(moment(selectedDateTime.date).date()) &&
    availableTime[moment(selectedDateTime.date).format("YYYY-MM-DD")]?.filter(
      (time) => time.split(" ")[1] === "PM"
    )?.length > 0;

  const selectedDate = useMemo(() => {
    return moment(selectedDateTime.date).format("YYYY-MM-DD");
  }, [selectedDateTime.date]);

  return isLoading ? (
    <></>
  ) : availableTime[selectedDate].length === 0 ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        p: "20px",
        marginTop: 2,
        gap: 1,
      }}
    >
      <img src={empty_schedule} width={85} height={85} />
      <Typography fontWeight={600} fontSize={18} color="#637381">
        No Available Time
      </Typography>
    </Box>
  ) : (
    <Box px={2} mt={1} height="calc(100% - 125px)" overflow="auto">
      {isExistsMorningTimes && (
        <>
          <Box className={classes.titleHeader}>Morning</Box>
          <Box className={classes.timeBox}>
            {availableTime[selectedDate]
              .filter((time) => time.split(" ")[1] === "AM")
              .map((time) => (
                <Button
                  className={classes.timeButton}
                  onClick={handlePickTime(time)}
                  key={time}
                >
                  {time}
                </Button>
              ))}
          </Box>
        </>
      )}
      {isExistsAfternoonTimes && (
        <>
          <Box className={classes.titleHeader}>Afternoon</Box>
          <Box className={classes.timeBox}>
            {availableTime[selectedDate]
              .filter((time) => time.split(" ")[1] === "PM")
              .map((time) => (
                <Button
                  className={classes.timeButton}
                  key={time}
                  onClick={handlePickTime(time)}
                >
                  {time}
                </Button>
              ))}
          </Box>
        </>
      )}
    </Box>
  );
};

export default TimeSection;
